import { getDPEFeatureFlag, ModelConstants } from 'shell-models-lib';

export const adfModelTypeMap = {
    azureKeyVault: {
        linkedServiceType: 'AzureKeyVault'
    },
    azureDataFactory: {
        linkedServiceType: 'AzureDataFactory'
    },
    azureSynapseAnalytics: {
        linkedServiceType: 'SynapseWorkspace'
    },
    fabricWorkspace: {
        linkedServiceType: 'FabricWorkspace'
    },
    concur: {
        linkedServiceType: 'Concur'
    },
    couchbase: {
        linkedServiceType: 'Couchbase'
    },
    azureSearch: {
        linkedServiceType: 'AzureSearch',
        datasetType: 'AzureSearchIndex',
        copySinkType: 'AzureSearchIndexSink'
    },
    azureSql: {
        linkedServiceType: ModelConstants.azureSqlDatabase,
        datasetType: 'AzureSqlTable',
        copySourceType: 'AzureSqlSource',
        copySinkType: 'AzureSqlSink',
        dataflowSettings: 'SqlDBSettings'
    },
    sqlServer: {
        linkedServiceType: ModelConstants.sqlServerLinkedService,
        datasetType: ModelConstants.sqlServerDataset,
        copySourceType: 'SqlServerSource',
        copySinkType: 'SqlServerSink',
        dataflowSettings: 'OnPremiseSqlServerSettings'
    },
    square: {
        linkedServiceType: 'Square'
    },
    sqlPool: {
        datasetType: 'SqlPoolTable',
        copySourceType: 'SqlPoolSource',
        copySinkType: 'SqlPoolSink',
        connectionType: 'sqlPool'
    },
    azureSqlDW: {
        linkedServiceType: ModelConstants.synapseLinkedService,
        datasetType: ModelConstants.synapseTableDataset,
        copySourceType: 'SqlDWSource',
        copySinkType: 'SqlDWSink',
        dataflowSettings: 'SynapseAnalyticsSettings'
    },
    sapOpenHub: {
        linkedServiceType: 'SapOpenHub',
        datasetType: 'SapOpenHubTable',
        copySourceType: 'SapOpenHubSource'
    },
    sapTable: {
        linkedServiceType: 'SapTable',
        datasetType: 'SapTableResource',
        copySourceType: 'SapTableSource'
    },
    sapOdp: {
        linkedServiceType: 'SapOdp',
        datasetType: 'SapOdpResource',
        copySourceType: 'SapOdpSource',
        dataflowSettings: 'SapODPSettings'
    },
    /**
     * @deprecated
     */
    sapCdc: {
        linkedServiceType: 'SapCDC',
        datasetType: 'SapCDCDataset',
        copySourceType: 'SapCDCSource',
        dataflowSettings: 'SapODPSettings'
    },
    sapBdc: {
        linkedServiceType: ModelConstants.sapBusinessDataCloudLinkedService,
        datasetType: 'SAPBusinessDataCloud'
    },
    sapOData: {
        linkedServiceType: ModelConstants.sapODataLinkedService,
        datasetType: ModelConstants.sapODataDataset,
        copySourceType: 'SapODataSource',
        dataflowSettings: 'SapODataSettings'
    },
    serviceNow: {
        linkedServiceType: ModelConstants.serviceNowLinkedService,
        datasetType: ModelConstants.serviceNowDataset,
        copySourceType: ModelConstants.serviceNowCopySource
    },
    serviceNowV2: {
        linkedServiceType: ModelConstants.serviceNowV2LinkedService,
        datasetType: ModelConstants.serviceNowV2Dataset,
        copySourceType: ModelConstants.serviceNowV2CopySource
    },
    teradata: {
        linkedServiceType: 'Teradata',
        datasetType: 'TeradataTable',
        copySourceType: 'TeradataSource',
        copySinkType: 'TeradataSink'
    },
    vertica: {
        linkedServiceType: 'Vertica',
        datasetType: 'VerticaTable',
        copySourceType: 'VerticaSource'
    },
    vivaInsights: {
        linkedServiceType: 'VivaInsights',
        datasetType: 'VivaInsightsReport',
        copySourceType: 'VivaInsightsSource'
    },
    microsoftAccess: {
        linkedServiceType: 'MicrosoftAccess',
        datasetType: 'MicrosoftAccessTable',
        copySourceType: 'MicrosoftAccessSource',
        copySinkType: 'MicrosoftAccessSink'
    },
    informix: {
        linkedServiceType: 'Informix',
        datasetType: 'InformixTable',
        copySourceType: 'InformixSource',
        copySinkType: 'InformixSink'
    },
    jira: {
        linkedServiceType: 'Jira',
        datasetType: 'JiraObject'
    },
    attio: {
        linkedServiceType: 'Attio',
        datasetType: 'AttioObject',
        copySourceType: 'AttioSource'
    },
    bitbucket: {
        linkedServiceType: 'Bitbucket',
        datasetType: 'BitbucketTable',
        copySourceType: 'BitbucketSource'
    },
    oracleFusion: {
        linkedServiceType: 'OracleFusion',
        datasetType: 'OracleFusionTable',
        copySourceType: 'OracleFusionSource'
    },
    lakehouse: {
        linkedServiceType: ModelConstants.lakehouseLinkedService,
        storeRead: 'LakehouseReadSettings'
    },
    lakehouseCredential: {
        linkedServiceType: ModelConstants.lakehouseCredentialLinkedService,
    },
    fabricMaterializedLakehouseView: {
        linkedServiceType: ModelConstants.fabricMaterializedLakehouseViewLinkedService,
    },
    lakehouseTable: {
        // linkedServiceType: uses lakehouse.linkedServiceType
        datasetType: ModelConstants.lakehouseTableDataset,
        copySourceType: 'LakehouseTableSource',
        copySinkType: 'LakehouseTableSink'
    },
    fabricSql: {
        linkedServiceType: ModelConstants.fabricSqlLinkedService,
        datasetType: ModelConstants.fabricSqlTableDataset,
        copySourceType: 'FabricSqlDatabaseSource',
        copySinkType: 'FabricSqlDatabaseSink'
    },
    fabricSqlCredential: {
        linkedServiceType: ModelConstants.fabricSqlCredentialLinkedService,
    },
    sqlAnalyticsEndpoint: {
        linkedServiceType: ModelConstants.sqlAnalyticsEndpointLinkedService,
        datasetType: ModelConstants.sqlAnalyticsEndpointDataset,
        copySourceType: ModelConstants.sqlAnalyticsEndpointCopySource,
    },
    sqlAnalyticsEndpointCredential: {
        linkedServiceType: ModelConstants.sqlAnalyticsEndpointCredentialLinkedService,
    },
    mountedRelationalDatabase: {
        linkedServiceType: ModelConstants.mountedRelationalDatabaseLinkedService,
        datasetType: ModelConstants.mountedRelationalDatabaseDataset,
        copySinkType: 'GenericMirrorSink'
    },
    magento: {
        linkedServiceType: 'Magento'
    },
    marketto: {
        linkedServiceType: 'Marketo'
    },
    relationalTable: {
        datasetType: 'RelationalTable',
        copySourceType: 'RelationalSource'
    },
    genericCData: {
        linkedServiceType: ModelConstants.genericCDataLinkedService,
        datasetType: ModelConstants.genericCDataTableDataset,
        copySourceType: ModelConstants.genericCDataCopySource
    },
    office365: {
        linkedServiceType: 'Office365',
        datasetType: 'Office365Table',
        copySourceType: 'Office365Source',
        dataflowSettings: 'Microsoft365Settings'
    },
    oracle: {
        linkedServiceType: 'Oracle',
        datasetType: 'OracleTable',
        copySourceType: 'OracleSource',
        copySinkType: 'OracleSink',
        dataflowSettings: 'OracleSettings'
    },
    oracleCloudStorage: {
        linkedServiceType: 'OracleCloudStorage',
        storeRead: 'OracleCloudStorageReadSettings'
    },
    oracleEloqua: {
        linkedServiceType: 'Eloqua'
    },
    oracleResponsys: {
        linkedServiceType: 'Responsys'
    },
    oracleServiceCloud: {
        linkedServiceType: 'OracleServiceCloud'
    },
    paypal: {
        linkedServiceType: 'PayPal'
    },
    phoenix: {
        linkedServiceType: 'Phoenix'
    },
    adobeExperiencePlatform: {
        linkedServiceType: 'AdobeExperiencePlatform',
        datasetType: 'AdobeExperiencePlatformObject',
        copySourceType: 'AdobeExperiencePlatformSource'
    },
    adobeIntegration: {
        linkedServiceType: 'AdobeIntegration'
    },
    adobeCampaign: {
        dataflowSettings: 'AdobeCampaignSettings'
    },
    adobeIOEvents: {
        dataflowSettings: 'AdobeEventsSettings'
    },
    adobePrivacy: {
        dataflowSettings: 'AdobePrivacySettings'
    },
    sapHana: {
        linkedServiceType: 'SapHana',
        datasetType: 'SapHanaTable',
        copySourceType: 'SapHanaSource'
    },
    sapBw: {
        linkedServiceType: 'SapBw',
        datasetType: 'SapBwCube',
        copySourceType: 'SapBwSource'
    },
    azureDataLakeStore: {
        linkedServiceType: 'AzureDataLakeStore',
        datasetType: 'AzureDataLakeStoreFile',
        copySourceType: 'AzureDataLakeStoreSource',
        copySinkType: 'AzureDataLakeStoreSink'
    },
    sftp: {
        linkedServiceType: ModelConstants.sftpLinkedService
    },
    amazonS3: {
        linkedServiceType: ModelConstants.amazonS3LinkedService,
        datasetType: 'AmazonS3Object',
        storeRead: 'AmazonS3ReadSettings'
    },
    amazonS3Compatible: {
        linkedServiceType: ModelConstants.amazonS3CompatibleLinkedService,
        storeRead: 'AmazonS3CompatibleReadSettings'
    },
    amazonRdsSqlServer: {
        linkedServiceType: 'AmazonRdsForSqlServer',
        datasetType: 'AmazonRdsForSqlServerTable',
        copySourceType: 'AmazonRdsForSqlServerSource'
    },
    azureDataLakeStoreCosmosStructuredStream: {
        linkedServiceType: 'AzureDataLakeStoreCosmosStructuredStream',
        datasetType: 'AzureDataLakeStoreCosmosStructuredStreamFile',
        copySourceType: 'AzureDataLakeStoreCosmosStructuredStreamSource'
    },
    azureDataLakeStoreGen2CosmosStructuredStream: {
        linkedServiceType: 'AdlsGen2CosmosStructuredStream',
        datasetType: 'AdlsGen2CosmosStructuredStreamFile',
        copySourceType: 'AdlsGen2CosmosStructuredStreamSource'
    },
    azureSqlMI: {
        linkedServiceType: 'AzureSqlMI',
        datasetType: 'AzureSqlMITable',
        copySourceType: 'SqlMISource',
        copySinkType: 'SqlMISink',
        dataflowSettings: 'SqlMISettings'
    },
    azureDataExplorer: {
        linkedServiceType: ModelConstants.azureDataExplorerLinkedService,
        datasetType: ModelConstants.azureDataExplorerDataset,
        copySourceType: 'AzureDataExplorerSource',
        copySinkType: 'AzureDataExplorerSink',
        dataflowSettings: 'AdxSettings'
    },
    /**
     * This is for `Trident🔱` Kusto workspace
     */
    kustoDatabase: {
        linkedServiceType: ModelConstants.kustoDatabaseLinkedService,
        datasetType: ModelConstants.kustoDatabaseDataset,
        copySourceType: 'KustoDatabaseSource',
        copySinkType: 'KustoDatabaseSink'
    },
    DataWarehouse: {
        linkedServiceType: ModelConstants.dataWarehouseLinkedService,
        datasetType: ModelConstants.dataWarehouseTableDataset,
        copySourceType: 'DataWarehouseSource',
        copySinkType: 'DataWarehouseSink'
    },
    Warehouse: {
        linkedServiceType: ModelConstants.warehouseLinkedService,
        datasetType: ModelConstants.warehouseTableDataset,
        copySourceType: 'WarehouseSource',
        copySinkType: 'WarehouseSink',
        dataflowSettings: 'WarehouseSettings'
    },
    warehouseCredential: {
        linkedServiceType: ModelConstants.warehouseCredentialLinkedService,
    },
    delimitedText: {
        datasetType: ModelConstants.delimitedTextDataset,
        copySourceType: 'DelimitedTextSource',
        copySinkType: 'DelimitedTextSink',
        dataflowSettings: 'DelimitedTextSettings',
        formatRead: 'DelimitedTextReadSettings',
        formatWrite: 'DelimitedTextWriteSettings'
    },
    iceberg: {
        datasetType: ModelConstants.icebergDataset,
        dataflowSettings: 'IcebergSettings',
        copySinkType: 'IcebergSink',
        formatWrite: 'IcebergWriteSettings'

    },
    parquet: {
        datasetType: ModelConstants.parquetDataset,
        copySourceType: 'ParquetSource',
        copySinkType: 'ParquetTextSink',
        dataflowSettings: 'ParquetSettings',
        formatRead: 'ParquetReadSettings',
        formatWrite: 'ParquetWriteSettings'
    },
    parquetInline: {
        dataflowSettings: 'ParquetInlineSettings'
    },
    json: {
        datasetType: ModelConstants.jsonDataset,
        copySourceType: 'JsonSource',
        copySinkType: 'JsonSink',
        dataflowSettings: 'JsonSettings',
        formatRead: 'JsonReadSettings',
        formatWrite: 'JsonWriteSettings'
    },
    xml: {
        datasetType: ModelConstants.xmlDataset,
        copySourceType: 'XmlSource',
        dataflowSettings: 'XmlSettings',
        formatRead: 'XmlReadSettings'
    },
    orc: {
        datasetType: ModelConstants.orcDataset,
        copySourceType: 'OrcSource',
        copySinkType: 'OrcSink',
        dataflowSettings: 'OrcSettings',
        formatWrite: 'OrcWriteSettings'
    },
    avro: {
        datasetType: ModelConstants.avroDataset,
        copySourceType: 'AvroSource',
        copySinkType: 'AvroSink',
        dataflowSettings: 'AvroSettings',
        formatWrite: 'AvroWriteSettings'
    },
    binary: {
        datasetType: ModelConstants.binaryDataset,
        copySourceType: 'BinarySource',
        copySinkType: 'BinarySink',
        formatRead: 'BinaryReadSettings'
    },
    excel: {
        datasetType: ModelConstants.excelDataset,
        copySourceType: 'ExcelSource',
        dataflowSettings: 'ExcelSettings'
    },
    cdm: {
        dataflowSettings: 'CdmSettings'
    },
    delta: {
        datasetType: ModelConstants.deltaFormat,
        copySourceType: 'DeltaSource',
        copySinkType: 'DeltaSink',
        dataflowSettings: 'DeltaSettings',
        formatRead: 'DeltaReadSettings',
        formatWrite: 'DeltaWriteSettings'
    },
    commonDataService: {
        dataflowSettings: 'DataverseSettings',
        linkedServiceType: 'CommonDataServiceForApps',
        datasetType: 'CommonDataServiceForAppsEntity',
        copySourceType: 'CommonDataServiceForAppsSource',
        copySinkType: 'CommonDataServiceForAppsSink'
    },
    dynamicsCRM: {
        linkedServiceType: 'DynamicsCrm',
        datasetType: 'DynamicsCrmEntity',
        copySourceType: 'DynamicsCrmSource',
        copySinkType: 'DynamicsCrmSink',
        dataflowSettings: 'DynamicsCrmSettings'
    },
    dynamics: {
        linkedServiceType: 'Dynamics',
        datasetType: 'DynamicsEntity',
        copySourceType: 'DynamicsSource',
        copySinkType: 'DynamicsSink',
        dataflowSettings: 'DynamicsSettings'
    },
    dynamicsAX: {
        linkedServiceType: 'DynamicsAX',
        datasetType: 'DynamicsAXResource',
        copySourceType: 'DynamicsAXSource'
    },
    salesforce: {
        linkedServiceType: ModelConstants.salesforceLinkedService,
        datasetType: ModelConstants.salesforceDataset,
        copySourceType: ModelConstants.salesforceCopySource,
        copySinkType: ModelConstants.salesforceCopySink
    },
    salesforceV2: {
        linkedServiceType: ModelConstants.salesforceV2LinkedService,
        datasetType: ModelConstants.salesforceV2Dataset,
        dataflowSettings: 'SalesforceSettings',
        copySourceType: ModelConstants.salesforceV2CopySource,
        copySinkType: ModelConstants.salesforceV2CopySink
    },
    salesforceServiceCloud: {
        datasetType: ModelConstants.salesforceServiceCloudDataset,
        linkedServiceType: ModelConstants.salesforceServiceCloudLinkedService,
        copySourceType: ModelConstants.salesforceServiceCloudCopySource,
        copySinkType: ModelConstants.salesforceServiceCloudCopySink
    },
    salesforceServiceCloudV2: {
        linkedServiceType: ModelConstants.salesforceServiceCloudV2LinkedService,
        datasetType: ModelConstants.salesforceServiceCloudV2Dataset,
        copySourceType: ModelConstants.salesforceServiceCloudV2CopySource,
        copySinkType: ModelConstants.salesforceServiceCloudV2CopySink
    },
    salesforceMarketingCloud: {
        linkedServiceType: 'SalesforceMarketingCloud'
    },
    sybase: {
        datasetType: 'SybaseTable',
        linkedServiceType: 'Sybase',
        copySourceType: 'SybaseSource'
    },
    cassandra: {
        linkedServiceType: 'Cassandra',
        datasetType: 'CassandraTable',
        copySourceType: 'CassandraSource',
        dataflowSettings: 'CassandraSettings'
    },
    azureBlob: {
        linkedServiceType: ModelConstants.blobLinkedService,
        datasetType: 'AzureBlob'
    },
    azureTable: {
        linkedServiceType: ModelConstants.azureTableLinkedService,
        datasetType: 'AzureTable'
    },
    azureQueue: {
        linkedServiceType: 'AzureQueueStorage'
    },
    azureStorage: {
        linkedServiceType: 'AzureStorage'
    },
    azureBlobFS: {
        linkedServiceType: ModelConstants.adlsGen2LinkedService,
        datasetType: 'AzureBlobFSFile'
    },
    ftpServer: {
        linkedServiceType: ModelConstants.ftpServerLinkedService
    },
    httpServer: {
        linkedServiceType: 'HttpServer',
        datasetType: 'HttpFile'
    },
    hubspot: {
        linkedServiceType: 'Hubspot',
        datasetType: 'HubspotObject',
        copySourceType: 'HubspotSource'
    },
    impala: {
        linkedServiceType: 'Impala',
        datasetType: 'ImpalaObject',
        copySourceType: 'ImpalaSource'
    },
    fileServer: {
        linkedServiceType: 'FileServer'
    },
    azureFileStorage: {
        linkedServiceType: ModelConstants.fileStorageService
    },
    googleCloudStorage: {
        linkedServiceType: ModelConstants.googleCloudStorageLinkedService,
        storeRead: 'GoogleCloudStorageReadSettings'
    },
    greenplum: {
        linkedServiceType: 'Greenplum',
        datasetType: 'GreenplumTable',
        copySourceType: 'GreenplumSource'
    },
    hbase: {
        linkedServiceType: 'HBase'
    },
    hdfs: {
        linkedServiceType: ModelConstants.hdfsLinkedService
    },
    snowflake: {
        linkedServiceType: ModelConstants.snowflakeLinkedService,
        datasetType: ModelConstants.snowflakeDataset,
        copySourceType: ModelConstants.snowflakeCopySource,
        copySinkType: ModelConstants.snowflakeCopySink,
        dataflowSettings: 'SnowflakeSettings'
    },
    snowflakeV2: {
        linkedServiceType: ModelConstants.snowflakeV2LinkedService,
        datasetType: ModelConstants.snowflakeV2Dataset,
        copySourceType: ModelConstants.snowflakeV2CopySource,
        copySinkType: ModelConstants.snowflakeV2CopySink,
        dataflowSettings: 'SnowflakeV2Settings'
    },
    spark: {
        linkedServiceType: 'Spark',
        datasetType: 'SparkObject',
        copySourceType: 'SparkSource'
    },
    databricks: {
        linkedServiceType: 'Databricks',
        datasetType: 'DatabricksDataset',
        copySourceType: 'DatabricksSource',
        copySinkType: 'DatabricksSink',
        importSettings: 'DatabricksImportCommand',
        exportSettings: 'DatabricksExportCommand'
    },
    azureMySql: {
        linkedServiceType: 'AzureMySql',
        datasetType: 'AzureMySqlTable',
        copySourceType: 'AzureMySqlSource',
        copySinkType: 'AzureMySqlSink',
        dataflowSettings: 'MysqlSettings'
    },
    azurePostgreSQL: {
        linkedServiceType: 'AzurePostgreSql',
        datasetType: 'AzurePostgreSqlTable',
        copySourceType: 'AzurePostgreSqlSource',
        copySinkType: 'AzurePostgreSqlSink',
        dataflowSettings: 'PostgreSqlSettings'
    },
    azureHorizonDb: {
        linkedServiceType: 'AzureHorizonDB',
        datasetType: 'AzureHorizonDBTable',
        copySourceType: 'AzureHorizonDBSource',
        copySinkType: 'AzureHorizonDBSink'
    },
    amazonMWSMetadata: {
        linkedServiceType: 'AmazonMWS'
    },
    amazonRedshift: {
        linkedServiceType: 'AmazonRedshift',
        datasetType: 'AmazonRedshiftTable',
        copySourceType: 'AmazonRedshiftSource',
        copySinkType: 'AmazonRedshiftSink'
    },
    kusto: {
        linkedServiceType: 'Kusto',
        datasetType: 'KustoTable'
    },
    azureMariaDB: {
        linkedServiceType: 'AzureMariaDB',
        datasetType: 'AzureMariaDBTable',
        copySourceType: 'AzureMariaDBSource'
    },
    mariaDB: {
        linkedServiceType: 'MariaDB',
        datasetType: 'MariaDBTable',
        copySourceType: 'MariaDBSource'
    },
    odata: {
        linkedServiceType: 'OData',
        datasetType: 'ODataResource',
        copySourceType: 'ODataSource'
    },
    db2: {
        linkedServiceType: 'Db2',
        datasetType: 'Db2Table',
        copySourceType: 'Db2Source'
    },
    drill: {
        linkedServiceType: 'Drill'
    },
    postgreSql: {
        linkedServiceType: 'PostgreSql',
        datasetType: 'PostgreSqlTable',
        copySourceType: 'PostgreSqlSource',
        copySinkType: 'PostgreSqlSink'
    },
    postgreSqlV2: {
        linkedServiceType: 'PostgreSqlV2',
        datasetType: 'PostgreSqlV2Table',
        copySourceType: 'PostgreSqlV2Source'
    },
    presto: {
        linkedServiceType: 'Presto',
        datasetType: 'PrestoObject',
        copySourceType: 'PrestoSource'
    },
    quickBooks: {
        linkedServiceType: 'QuickBooks',
        datasetType: 'QuickBooksObject',
        copySourceType: 'QuickBooksSource'
    },
    rest: {
        linkedServiceType: 'RestService',
        datasetType: 'RestResource',
        copySourceType: 'RestSource',
        copySinkType: 'RestSink',
        dataflowSettings: 'RestSettings'
    },
    restCall: {
        dataflowSettings: 'RestCallSettings'
    },
    odbc: {
        linkedServiceType: 'Odbc',
        datasetType: 'OdbcTable',
        copySourceType: 'OdbcSource',
        copySinkType: 'OdbcSink'
    },
    mysql: {
        linkedServiceType: 'MySql',
        datasetType: 'MySqlTable',
        copySourceType: 'MySqlSource',
        copySinkType: 'MySqlSink',
    },
    netezza: {
        linkedServiceType: 'Netezza',
        datasetType: 'NetezzaTable',
        copySourceType: 'NetezzaSource'
    },
    cosmosSql: {
        datasetType: 'CosmosDbSqlApiCollection',
        copySourceType: 'CosmosDbSqlApiSource',
        copySinkType: 'CosmosDbSqlApiSink',
        linkedServiceType: 'CosmosDb',
        dataflowSettings: 'CosmosSqlSettings'
    },
    cosmosMongo: {
        linkedServiceType: 'CosmosDbMongoDbApi',
        datasetType: 'CosmosDbMongoDbApiCollection',
        copySourceType: 'CosmosDbMongoDbApiSource',
        copySinkType: 'CosmosDbMongoDbApiSink',
        dataflowSettings: 'CosmosMongoSettings'
    },
    mongoDbAtlas: {
        linkedServiceType: 'MongoDbAtlas',
        copySourceType: 'MongoDbAtlasSource',
        copySinkType: 'MongoDbAtlasSink',
        datasetType: 'MongoDbAtlasCollection'
    },
    mongoDb: {
        linkedServiceType: 'MongoDbV2',
        copySourceType: 'MongoDbV2Source',
        copySinkType: 'MongoDbV2Sink',
        datasetType: 'MongoDbV2Collection'
    },
    gitHub: {
        linkedServiceType: 'GitHub'
    },
    googleAdWords: {
        datasetType: 'GoogleAdWordsObject',
        linkedServiceType: 'GoogleAdWords'
    },
    googleBigQuery: {
        linkedServiceType: 'GoogleBigQuery',
        datasetType: 'GoogleBigQueryObject',
        copySourceType: 'GoogleBigQuerySource',
        copySinkType: 'GoogleBigQuerySink'
    },
    googleBigQueryV2: {
        linkedServiceType: 'GoogleBigQueryV2',
        datasetType: 'GoogleBigQueryV2Object',
        copySourceType: 'GoogleBigQueryV2Source'
    },
    sharePointOnlineList: {
        linkedServiceType: 'SharePointOnlineList',
        datasetType: 'SharePointOnlineListResource',
        copySourceType: 'SharePointOnlineListSource'
    },
    sharePointOnlineFile: {
        linkedServiceType: 'SharePointOnlineFile',
        storeRead: 'SharePointOnlineFileStoreReadSettings',
        copySourceType: 'SharePointOnlineFileSource',
        copySinkType: 'SharePointOnlineFileSink'
    },
    hive: {
        linkedServiceType: 'Hive',
        datasetType: 'HiveObject',
        copySourceType: 'HiveSource',
        dataflowSettings: 'HiveSettings'
    },
    shopify: {
        linkedServiceType: 'Shopify'
    },
    azureDatabricksDeltaLake: {
        linkedServiceType: 'AzureDatabricksDeltaLake',
        datasetType: 'AzureDatabricksDeltaLakeDataset',
        copySourceType: 'AzureDatabricksDeltaLakeSource',
        copySinkType: 'AzureDatabricksDeltaLakeSink'
    },
    webTable: {
        linkedServiceType: 'Web',
        datasetType: 'WebTable',
        copySourceType: 'WebSource'
    },
    xero: {
        linkedServiceType: 'Xero'
    },
    zoho: {
        linkedServiceType: 'Zoho'
    },
    sapc4c: {
        linkedServiceType: 'SapCloudForCustomer',
        datasetType: 'SapCloudForCustomerResource',
        copySourceType: 'SapCloudForCustomerSource',
        copySinkType: 'SapCloudForCustomerSink'
    },
    sapecc: {
        linkedServiceType: 'SapEcc',
        datasetType: 'SapEccResource',
        copySourceType: 'SapEccSource'
    },
    sapDatasphereForAzureDataLakeStorageGen2: {
        linkedServiceType: ModelConstants.sapDatasphereForAzureDataLakeStorageGen2LinkedService,
        storeRead: 'SapDatasphereForAzureDataLakeStorageGen2ReadSettings'
    },
    oneLakeFile: {
        linkedServiceType: ModelConstants.oneLakeFileLinkedService,
        storeRead: 'OneLakeFilesReadSettings',
        storeWrite: 'OneLakeFilesWriteSettings'
    },
    sapDatasphereForGoogleCloudStorage: {
        linkedServiceType: ModelConstants.sapDatasphereForGoogleCloudStorageLinkedService,
        storeRead: 'SapDatasphereForGoogleCloudStorageReadSettings'
    },
    sapDatasphereForAmazonS3: {
        linkedServiceType: ModelConstants.sapDatasphereForAmazonS3LinkedService,
        storeRead: 'SapDatasphereForAmazonS3ReadSettings'
    },
    eventHubs: {
        linkedServiceType: 'EventHubs',
        datasetType: 'EventHubsDataset',
        dataflowSettings: 'EventHubsSettings'
    },
    cognitiveService: {
        linkedServiceType: 'CognitiveService'
    },
    // compute
    hdInsight: {
        linkedServiceType: 'HDInsight'
    },
    hDInsightOnDemand: {
        linkedServiceType: 'HDInsightOnDemand'
    },
    azureBatch: {
        linkedServiceType: 'AzureBatch'
    },
    azureMl: {
        linkedServiceType: 'AzureML'
    },
    amlService: {
        linkedServiceType: 'AzureMLService'
    },
    azureDataLakeAnalytics: {
        linkedServiceType: 'AzureDataLakeAnalytics'
    },
    azureDatabricks: {
        linkedServiceType: 'AzureDatabricks'
    },
    azureFunction: {
        linkedServiceType: 'AzureFunction'
    },
    webActivity: {
        linkedServiceType: 'WebConnection'
    },
    fileSystem: {
        copySourceType: 'FileSystemSource',
        copySinkType: 'FileSystemSink'
    },
    sql: {
        copySourceType: 'SqlSource'
    },
    amazonRdsForOracle: {
        linkedServiceType: 'AmazonRdsForOracle',
        datasetType: 'AmazonRdsForOracleTable',
        copySourceType: 'AmazonRdsForOracleSource'
    },
    teamDesk: {
        linkedServiceType: 'TeamDesk',
        dataflowSettings: 'TeamDeskSettings'
    },
    quickbase: {
        linkedServiceType: 'Quickbase',
        dataflowSettings: 'QuickbaseSettings'
    },
    smartsheet: {
        linkedServiceType: 'Smartsheet',
        dataflowSettings: 'SmartsheetSettings'
    },
    zendesk: {
        linkedServiceType: 'Zendesk',
        dataflowSettings: 'ZendeskSettings'
    },
    azureSynapseArtifacts: {
        linkedServiceType: 'AzureSynapseArtifacts'
    },
    trino: {
        linkedServiceType: 'AzureTrino',
        datasetType: 'TrinoObject',
        // Todo: backend not yet telling the exact type
        copySourceType: 'TrinoSource'
    },
    workday: {
        linkedServiceType: 'Workday',
        dataflowSettings: 'WorkdaySettings'
    },
    kafka: {
        linkedServiceType: 'Kafka',
        datasetType: 'KafkaDataset',
        dataflowSettings: 'KafkaSettings'
    },
    powerBIDatasets: {
        linkedServiceType: 'PowerBIDatasets'
    },
    fabricDataPipelines: {
        linkedServiceType: 'FabricDataPipelines'
    },
    microsoftTeams: {
        linkedServiceType: ModelConstants.microsoftTeamsLinkedService
    },
    office365Email: {
        linkedServiceType: ModelConstants.office365EmailLinkedService
    },
    tridentSparkJobDefinition: {
        linkedServiceType: ModelConstants.sparkJobDefinitionLinkedService
    },
    fabricNotebook: {
        linkedServiceType: ModelConstants.fabricNotebookLinkedService
    },
    fabricAirflow: {
        linkedServiceType: ModelConstants.fabricAirflowLinkedService
    },
    fabricUserDataFunctions: {
        linkedServiceType: ModelConstants.udfLinkedService
    },
    fabricDataflow: {
        linkedServiceType: ModelConstants.fabricDataflowLinkedService
    },
    invokeCopyJob: {
        linkedServiceType: ModelConstants.invokeCopyJobLinkedService
    },
    invokeDataBuildToolJob: {
        linkedServiceType: ModelConstants.dataBuildToolJobLinkedService
    },
    invokeDataQuality: {
        linkedServiceType: ModelConstants.dataQualityLinkedService
    },
    fabricWeb: {
        linkedServiceType: ModelConstants.fabricWebLinkedService
    },
    fabricSqlEndpoint: {
        linkedServiceType: ModelConstants.fabricSqlEndpointMetadataLinkedService
    },
    eventStream: {
        linkedServiceType: ModelConstants.eventStreamLinkedService,
        datasetType: ModelConstants.eventStreamDataset,
        copySourceType: 'FabricEventStreamSource',
        copySinkType: 'EventStreamSink'
    },
    eventStreamCredential: {
        linkedServiceType: ModelConstants.eventStreamCredentialLinkedService
    }

};

// EventStream uses a different connectionSettings.type for the destination in the CopyJob payload
// ('EventStreamSink' instead of 'EventStream'). This function resolves it back to the linkedServiceType for the load path.
export function resolveLinkedServiceType(rawType: string | undefined): string | undefined {
    if (rawType === adfModelTypeMap.eventStream.copySinkType) {
        return adfModelTypeMap.eventStream.linkedServiceType;
    }
    return rawType;
}

export type formatTypeDatasetType = 'DelimitedText' | 'Parquet' | 'ORC' | 'Avro' | 'Json' | 'Binary' | 'Delta' | 'Iceberg';
export type formatTypeCopySourceType = 'DelimitedTextSource' | 'ParquetSource' | 'JsonSource' | 'ORCSource' | 'AvroSource' | 'BinarySource' | 'IcebergTableSource';
export type formatTypeCopySinkType = 'DelimitedTextSink' | 'ParquetTextSink' | 'JsonSink' | 'ORCSink' | 'AvroSink' | 'BinarySink' | 'DeltaSink';

const _m365SupportedSinkTypes = [adfModelTypeMap.azureBlob.linkedServiceType, adfModelTypeMap.azureBlobFS.linkedServiceType, adfModelTypeMap.azureDataLakeStore.linkedServiceType];
export const m365SupportedSinkTypes = __IS_FABRIC_DPE__ ? [..._m365SupportedSinkTypes, adfModelTypeMap.lakehouse.linkedServiceType] : _m365SupportedSinkTypes;
export const formatTypeDatasetTypes = [
    adfModelTypeMap.delimitedText.datasetType, adfModelTypeMap.parquet.datasetType, adfModelTypeMap.orc.datasetType,
    adfModelTypeMap.avro.datasetType, adfModelTypeMap.json.datasetType, adfModelTypeMap.binary.datasetType, adfModelTypeMap.iceberg.datasetType
];
export const formatTypeCopySourceTypes = [
    adfModelTypeMap.delimitedText.copySourceType, adfModelTypeMap.parquet.copySourceType, adfModelTypeMap.orc.copySourceType,
    adfModelTypeMap.avro.copySourceType, adfModelTypeMap.json.copySourceType, adfModelTypeMap.binary.copySourceType
];
export const formatTypeCopySinkTypes = [
    adfModelTypeMap.delimitedText.copySinkType, adfModelTypeMap.parquet.copySinkType, adfModelTypeMap.orc.copySinkType,
    adfModelTypeMap.avro.copySinkType, adfModelTypeMap.json.copySinkType, adfModelTypeMap.binary.copySinkType
];

export const fileTypeLinkedServiceTypes = [
    adfModelTypeMap.azureBlob.linkedServiceType,
    adfModelTypeMap.azureDataLakeStore.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.amazonS3Compatible.linkedServiceType,
    adfModelTypeMap.oracleCloudStorage.linkedServiceType,
    adfModelTypeMap.ftpServer.linkedServiceType,
    adfModelTypeMap.httpServer.linkedServiceType,
    adfModelTypeMap.hdfs.linkedServiceType,
    adfModelTypeMap.fileServer.linkedServiceType,
    adfModelTypeMap.sftp.linkedServiceType,
    adfModelTypeMap.azureFileStorage.linkedServiceType,
    adfModelTypeMap.googleCloudStorage.linkedServiceType,
    adfModelTypeMap.sharePointOnlineFile.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType,
    // OneLake File is a feature-flagged connector; only include it when registered, otherwise
    // consumers that resolve these types via getLinkedServiceConfiguration would fail.
    ...(__IS_FABRIC_DPE__ && getDPEFeatureFlag('oneLakeFileConnector')
        ? [adfModelTypeMap.oneLakeFile.linkedServiceType]
        : [])
];

export const dataConsistencySourceLinkedServiceTypes = [
    adfModelTypeMap.azureBlob.linkedServiceType,
    adfModelTypeMap.azureDataLakeStore.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.hdfs.linkedServiceType,
    adfModelTypeMap.fileServer.linkedServiceType,
    adfModelTypeMap.azureFileStorage.linkedServiceType,
    adfModelTypeMap.sharePointOnlineFile.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType
];

export const dataConsistencySinkLinkedServiceTypes = [
    adfModelTypeMap.azureBlob.linkedServiceType,
    adfModelTypeMap.azureDataLakeStore.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.fileServer.linkedServiceType,
    adfModelTypeMap.azureFileStorage.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.amazonS3Compatible.linkedServiceType,
    adfModelTypeMap.googleCloudStorage.linkedServiceType
];

export const skipForbiddenFilesSourceLinkedServiceTypes = [
    adfModelTypeMap.azureBlob.linkedServiceType,
    adfModelTypeMap.azureDataLakeStore.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.hdfs.linkedServiceType,
    adfModelTypeMap.sftp.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType
];

export const skipFilesWithInvalidNamesSinkLinkedServiceTypes = [
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType
];

export const skipFilesWithInvalidNamesSourceLinkedServiceTypes = [
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType
];

export const snowflakeLinkedServiceTypes = [
    adfModelTypeMap.snowflake.linkedServiceType,
    adfModelTypeMap.snowflakeV2.linkedServiceType
];

export const snowflakeDatasetTypes = [
    adfModelTypeMap.snowflake.datasetType,
    adfModelTypeMap.snowflakeV2.datasetType
];
